import { useState } from "react";

interface UseForgotPasswordReturn {
  isSubmitted: boolean;
  isLoading: boolean;
  error: string | null;
  submitEmail: (email: string) => Promise<void>;
  reset: () => void;
}

export const useForgotPassword = (): UseForgotPasswordReturn => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submitEmail = async (email: string) => {
    setIsLoading(true);
    setError(null);

    try {
      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setIsSubmitted(true);
    } catch (err) {
      setError("Gửi email thất bại. Vui lòng thử lại.");
    } finally {
      setIsLoading(false);
    }
  };

  const reset = () => {
    setIsSubmitted(false);
    setIsLoading(false);
    setError(null);
  };

  return {
    isSubmitted,
    isLoading,
    error,
    submitEmail,
    reset,
  };
};
